import JSZip from 'jszip'

const SUPPORTED_IMPORT_FILE = /\.(?:sst|ssc|scribe|csv|xls|xlsx|txt)$/i

export function normalizeImportPath(value = '') {
  const parts = String(value || '')
    .replace(/\\/g, '/')
    .replace(/^[A-Za-z]:\/?/, '')
    .split('/')
    .filter((part) => part && part !== '.')
  const safe = []
  parts.forEach((part) => {
    if (part === '..') safe.pop()
    else safe.push(part)
  })
  return safe.join('/')
}

function importBasename(path = '') {
  const normalized = normalizeImportPath(path)
  return normalized.split('/').filter(Boolean).pop() || 'archivo'
}

function extractedFile(blob, relativePath, archive) {
  const file = new File([blob], importBasename(relativePath), {
    type: blob.type || 'application/octet-stream',
    lastModified: archive.lastModified || Date.now(),
  })
  return {
    file,
    relativePath,
    archiveName: archive.name,
    fromArchive: true,
  }
}

export async function expandSstImportFiles(inputFiles = []) {
  const expanded = []

  for (const input of inputFiles) {
    if (!/\.zip$/i.test(String(input?.name || ''))) {
      const relativePath = normalizeImportPath(input?.webkitRelativePath || input?.name || '')
      if (SUPPORTED_IMPORT_FILE.test(relativePath)) {
        expanded.push({ file: input, relativePath, archiveName: '', fromArchive: false })
      }
      continue
    }

    const zip = await JSZip.loadAsync(input)
    const entries = Object.values(zip.files)
      .filter((entry) => !entry.dir)
      .map((entry) => ({ entry, relativePath: normalizeImportPath(entry.name) }))
      .filter(({ relativePath }) => relativePath && !/(?:^|\/)__MACOSX(?:\/|$)/i.test(relativePath))
      .filter(({ relativePath }) => SUPPORTED_IMPORT_FILE.test(relativePath))
      .sort((left, right) => left.relativePath.localeCompare(right.relativePath))

    for (const { entry, relativePath } of entries) {
      const blob = await entry.async('blob')
      expanded.push(extractedFile(blob, relativePath, input))
    }
  }

  return expanded
}

export function buildSstConversionOptions(entry, entries = []) {
  const sourcePath = normalizeImportPath(entry?.relativePath || entry?.name || 'script.sst')
  return {
    fileName: sourcePath,
    sourcePath,
    catalogFiles: (entries || [])
      .filter((candidate) => /\.csv$/i.test(String(candidate?.relativePath || candidate?.name || '')))
      .map((candidate) => ({
        path: normalizeImportPath(candidate.relativePath || candidate.name),
        content: String(candidate.content || ''),
      })),
  }
}

